<template>
  <div class="modal"
		data-backdrop="static"
		id="addAction"
		role="dialog"
		tabindex="-1"
		aria-labelledby="addCampaignGroup"
		aria-hidden="true"
     @click="stopClose($event)">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
						<h5 class="modal-title">Add Actions</h5>
						<button type="button" class="close" data-dismiss="modal" @click="closeAddActionModal();resetNullValidation()">
							<span aria-hidden="true">&times;</span>
				  	</button>
				</div>
        <div class="modal-body main_form_block">
          <div class="col-md-12">
            <div class="row ">
              <div class="col-md-12">
                <div
                  v-if="showActionListLoader"
                  style="margin:auto;display:block;margin-top:10px;margin-bottom:10px"
                  class="spinner-border"
                ></div>
                <div v-else>
                  <div style="padding:20px">
                    <div
                      style="margin-bottom:15px"
                      v-for="(item,index) in afterfilledActions"
                      :key="'afterfilledActions_1_' + index"
                    >
                      <div class="form-group row">
                        <div class="col-md-5" @click="stopMoving">
                          <multiselect
                            class="form-control multi-dropdown select_filter"
                            v-model="selectedAction[index]"
                            placeholder="Select Type"
                            label="name"
                            deselectLabel
                            selectedLabel
                            openDirection="below"
                            selectLabel
                            :disabled="disableTheSelected[index]"
                            :options="actionTypeList"
                            track-by="action_id"
                            ref="multiselect"
                            @input="setDefaultValue($event,selectedAction[index], index);resetNullValidation()"
                            :multiple="false"
                            :taggable="false"
                          ></multiselect>
                        </div>
                        <div
                          v-if="selectedAction[index] && (selectedAction[index].entity_data_type?(selectedAction[index].entity_data_type=='text'?true:false):false)"
                          class="col-md-5"
                        >
                          <input
                            style="height:93%;"
                            :type="computeTypeForAdd(selectedAction[index])"
                            placeholder="Enter value"
                            required="true"
                            autocomplete="off"
                            v-model="selectedValue[index]"
                            class="form-control"
                            @input="checkNoValueChange($event);resetNullValidation()"
                            id="value"
                            :onkeydown="computeTypeForAdd(selectedAction[index])=='number'?'javascript: return event.keyCode == 69 ? false : true':''"
                          />
                        </div>
                        <div
                          v-if="selectedAction[index] && (selectedAction[index].entity_data_type?(selectedAction[index].entity_data_type=='multiselect'?true:false):false)"
                          class="col-md-5 guardrail-tags"
                          style
                          @click="stopMoving"
                        >
                          <multiselect
                            v-model="selectedValue[index]"
                            :options="selectedNotificationValue"
                            :closeOnSelect="false"
                            :multiple="true"
                            :taggable="true"
                            label="name"
                            track-by="name"
                            @tag="addNotification($event,index);resetNullValidation()"
                            placeholder="Add Email"
                            tag-placeholder="Add Email"
                            class="form-control multi-dropdown select_filter"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            tagPosition="bottom"
                          ></multiselect>
                        </div>

                        <div
                          style="padding:10px;"
                          v-if="selectedAction[index] && (selectedAction[index].entity_data_type?(selectedAction[index].entity_data_type=='boolean'?true:false):false)"
                          class="col-md-5"
                        >
                          <toggle-button
                            style="margin-left:6px"
                            v-model="selectedValue[index]"
                            @input="checkNoValueChange($event)"
                          />
                        </div>

                        <div
                          v-if="(afterfilledActions.length!=(oldActionTypeList.length))&&index==afterfilledActions.length-1&&(selectedAction[index]!=null&&selectedValue[index]!=='')&&actionTypeList.length>0"
                          style="padding-top:8px"
                          @click="stopMoving"
                        >
                          <button
                            class="btn btn-primary add-new-campaign"
                            @click="addAction($event,index);resetNullValidation()"
                            id="submit"
                          >
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                        <div
                          v-if="selectedAction[index]!=null&&selectedValue[index]!==''"
                          style="padding-top:8px"
                        >
                          <button
                            class="btn btn-primary add-new-campaign"
                            style="background-color:red"
                            @click="removeAction($event,selectedAction[index],index);resetNullValidation()"
                            id="submit"
                          >X</button>
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        v-if="selectedAction[index] && selectedAction[index].name == 'Notification'"
                      >
                        <div class="col-md-5">
                          <div class="form-control multi-dropdown">
                            <label for="name">Select Template</label>
                          </div>
                        </div>
                        <div class="col-md-5 guardrail-tags">
                          <multiselect
                            v-model="template"
                            :options="template_list"
                            :searchable="true"
                            ref="multiselect"
                            label="title"
                            track-by="title"
                            open-direction="bottom"
                            selectLabel
                            deselectLabel
                            selectedLabel
                            class="form-control multi-dropdown col-md-12 select_filter"
                            :multiple="false"
                            id="keywordTags"
                          ></multiselect>
                        </div>
                      </div>
                    </div>
                    <span v-if="nullPresent" class ="no-data-style mr-1 ml-1" >Provide all fields to proceed.</span>
                  </div>
                </div>
                <span
                  v-if="cannotEdit"
                  style="padding:20px"
                  class="no-data-style"
                >Max budget should be greater then min budget</span>

              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content:center;">
                  <div
                    v-if="showNewLoader"
                    style="margin:auto;display:block;margin-top:10px;margin-bottom:10px"
                    class="spinner-border"
                  ></div>
                  <div v-else>
                    <button class="btn btn-secondary" @click="closeAddActionModal();resetNullValidation()"  data-dismiss="modal">Cancel</button>
                    <button class="btn btn-primary" @click="submitAction($event)" id="submit"  data-dismiss="modal">Save</button>
                  </div>
                </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  name: "AddActionInGuardrail",
  components: {
    Multiselect,
  },
  data() {
    return {
      showActionListLoader: false,
      flag: false,
      actionTypeList: [],
      disableTheSelected: [],
      selectedAutomation: {},
      selectedAction: [],
      selectedValue: [],
      preSelectedValue: "",
      afterfilledActions: [],
      updatedActionData: [],
      sendNotification: false,
      emailList: [],
      actionValueList: [[]],
      showNewLoader: false,
      selectedNotificationValue: [],
      cannotEdit: false,
      template_list: [],
      template: null,
      nullPresent:false
    };
  },
  props: [
    "guardrailId",
    "targetValue",
  ],
  computed: {
    oldActionTypeList: {
      get() {
        return this.$store.state.automation.actionTypeList;
      },
    },
  },
  mounted() {
    const vm = this;
    let target = JSON.parse(JSON.stringify(this.targetValue || {})).name;
    this.showActionListLoader = true
    this.$store
      .dispatch("automation/getActionTypeList", { type: target })
      .then((res) => {
        vm.flag = true;
        vm.actionTypeList = vm.oldActionTypeList;
         {
          vm.selectedAutomation = {id: vm.guardrailId}
          vm.afterfilledActions.push({
            list1: vm.actionTypeList,
            list2: vm.actionValueList,
          });
        }
        vm.showActionListLoader = false;
      });

	  let type = {
		  type: target
	  }
	  this.$store.dispatch("template/getTemplateList", type).then((res) => {
		  vm.template_list = res
	  })
  },
  watch: {
    sendNotification() {
      if (this.sendNotification) {
        this.addEmail();
      } else {
        this.emailList = [];
      }
    },

  },
  methods: {
    resetNullValidation(){
				this.nullPresent = false
			},
    computeTypeForAdd(action){
				let type = 'text'
				if(action){
					type = ((action.name||'').trim() == 'Min Budget' || (action.name||'').trim() == 'Max Budget' || (action.name||'').trim() == 'DecreaseACOS') ? 'number' : 'text'
				}			
				return type				
			},
    closeAddActionModal(){
      this.$emit('hideAddAction')
    },
    removeAction(e, selectedValue, index) {
      //e.stopPropagation();
      this.afterfilledActions.splice(index, 1);
      this.updatedActionData.splice(index, 1);
      this.selectedAction.splice(index, 1);
      this.selectedValue.splice(index, 1);
      if (selectedValue) {
        var duplicate = false;
        for (var i = 0; i < this.actionTypeList.length; i++) {
          if (this.actionTypeList[i].name == selectedValue.name) {
            duplicate = true;
            break;
          }
        }
        if (!duplicate) {
          this.actionTypeList.push(selectedValue);
        }
      }
      this.disableTheSelected.pop();
      if (this.afterfilledActions.length < 1) {
        this.afterfilledActions.push({
          list1: this.actionTypeList,
          list2: this.actionValueList,
        });
      }
    },
    stopMoving(e) {
      e.stopPropagation();
    },
    checkNoValueChange(e) {
      this.cannotEdit = false;
      if (this.actions && this.actions.length) {
        var isMax = this.actions.find((e) => e.title.trim() == "Max Budget");
        var isMin = this.actions.find((e) => e.title.trim() == "Min Budget");
        var newMax = -1;
        var newMin = -1;
        newMax = this.selectedAction.findIndex(
          (e) => e.name.trim() == "Max Budget"
        );
        newMin = this.selectedAction.findIndex(
          (e) => e.name.trim() == "Min Budget"
        );

        if (isMax && newMin != -1) {
          if (parseInt(isMax.value) < parseInt(this.selectedValue[newMin])) {
            this.cannotEdit = true;
          }
        }
        if (isMin && newMax != -1) {
          if (parseInt(isMin.value) > parseInt(this.selectedValue[newMax])) {
            this.cannotEdit = true;
          }
        }
      }
    },
    addNotification(value, index) {
      let isComma = value.includes(",");
      if (index != undefined) {
        let arr = this.selectedValue[index].length
          ? this.selectedValue[index]
          : [];
        if (isComma) {
          let data = value.split(",");
          data.map((value) => {
            arr.push({ name: value });
          });
        } else {
          arr.push({ name: value });
        }
        this.selectedValue[index] = arr;
        this.selectedNotificationValue = arr;
      } else {
        let arr = [...this.preSelectedValue];
        if (isComma) {
          let data = value.split(",");
          data.map((value) => {
            arr.push({ name: value });
          });
        } else {
          arr.push({ name: value });
        }
        this.preSelectedValue = arr;
      }
    },
    stopClose(e) {
      e.stopPropagation();
    },
    setDefaultValue(e, entity, index, type) {
      {
        this.selectedValue[index] = "";
        if (entity ? entity.entity_data_type == "boolean" : false) {
          this.selectedValue[index] = false;
        }
        if(e.name=='Notification'){
						this.template = null
					}
      }
    },
    addEmail() {
      if (this.emailList.length < 3) {
        this.emailList.push("");
      }
    },
    addAction(e, index) {
      this.flag = false;
      let vm = this;
      if (
        this.selectedAction[index] != null &&
        this.selectedValue[index] !== ""
      ) {
        this.updatedActionData.push({
          action_id: this.selectedAction[index].action_id,
          name: this.selectedValue[index],
          action_name: this.selectedAction[index].name,
          entity_type: this.selectedAction[index].entity_data_type,
          action_type: this.selectedAction[index].action_type,
        });
        vm.actionTypeList = vm.actionTypeList.filter(function (obj) {
          return obj.action_id != vm.selectedAction[index].action_id;
        });
        this.disableTheSelected.push(true);
      }
      this.updatedActionData.forEach((action) => {
        vm.actionTypeList = vm.actionTypeList.filter(function (obj) {
          return obj.action_id != action.action_id;
        });
      });
      this.afterfilledActions.push({
        list1: this.actionTypeList,
      });
    },
    limitText(count) {
      return ` and ${count} more...`;
    },
    ifNullExist(){
					var emptyAction = this.selectedAction.filter(item=> {
						if(!item || !item.action_id){
							return true
						}
					})
					var emptyValue = this.selectedValue.filter(item=> {
						if(!item.toString().trim()){
							return true
						}
					})
					if(this.selectedAction.length<1 || this.selectedValue.length<1 || this.selectedAction.length!=this.selectedValue.length){
						return true
					}
					if(emptyAction.length || emptyValue.length){
						return true
					}
					else{
						return false
					}
			},
    submitAction(e) {
      e.stopPropagation();
      let vm = this;
      this.nullPresent = false
				if(this.ifNullExist()){
					this.nullPresent = true
					return true
				}
      if (!this.cannotEdit) {
        {
          var actionData = {
            action: [],
            sendNotification: "",
            email: [],
            automationId: "",
            entity_type: "",
            action_type: "",
          };
          if (vm.updatedActionData.length == vm.afterfilledActions.length - 1) {
            const index = vm.updatedActionData.length;
            if (
              vm.selectedAction[index] != null &&
              vm.selectedValue[index] !== ""
            ) {
              vm.updatedActionData.push({
                action_id: vm.selectedAction[index].action_id,
                name: vm.selectedValue[index],
                action_name: vm.selectedAction[index].name,
                entity_type: vm.selectedAction[index].entity_data_type,
                action_type: vm.selectedAction[index].action_type,
              });
            }
          }

          vm.updatedActionData = vm.updatedActionData.map((res, i) => {
            res.name = vm.selectedValue[i];
            return res;
          });

          vm.updatedActionData.forEach((action) => {
            actionData.action.push({
              id: action.action_id,
              value:
                action.entity_type == "multiselect"
                  ? JSON.stringify(action.name)
                  : action.name,
              action_value: action.action_name,
              entity_type: action.entity_type,
              action_type: action.action_type,
            });
          });
          actionData.automationId = this.selectedAutomation.id;

          actionData.action.forEach((res, index) => {
            if (res.action_value == "Notification") {
              actionData.action[index].template = this.template;
            }
          });

          if (vm.validate(vm.updatedActionData)) {
            vm.showNewLoader = true;
            vm.$store
              .dispatch("automation/updateAutomation", actionData)
              .then((resposne) => {
                vm.showNewLoader = false;
                vm.navigateToAutomation()
              });
          }
        }
      }
    },
    navigateToAutomation(){
      this.$emit('navigateToList', '/automation2')
      //this.$router.push('/automation2')
    },
    validate(data) {
      if (data && data.length) {
        let isMin = data.find((e) => e.action_name.trim() == "Min Budget");
        let isMax = data.find((e) => e.action_name.trim() == "Max Budget");
        if (isMin && isMax) {
          if (parseInt(isMin.name) > parseInt(isMax.name)) {
            this.cannotEdit = true;
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
};
</script>
<style lang="scss" media="screen">
.col-md-12.row.active {
  background: #f7f7f7;
  border-right: 4px solid #ddd !important;
}
.scrollbar {
  float: left;
  height: 100vh;
  overflow: auto;
  background: #fff;
  overflow-y: scroll;
  margin-bottom: 25px;
}
.scrollbar-primary::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}
.popover-custom-wraps {
  width: 100%;
  min-width: 800px;
  background: #d4d4d4;
  padding: 2px;
  border-radius: 5px;
}
.popover-custom-wraps {
  .multiselect__tags-wrap {
    max-width: 290px;
  }
}
.popover-custom-wraps .multiselect__input,
.multiselect__single {
  display: block;
  overflow: hidden;
}
.popover-custom-wraps {
  .multiselect__tags-wrap {
    display: inline-grid;
  }
}
.popover-custom-wraps {
  .multiselect__strong {
    display: block;
  }
}
.arrow-up {
  width: 0;
  height: 12px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #d4d4d4;
}

.guardrail-tags {
  .multiselect__tag{
    text-transform:none !important
  }
}
.guardrail-tags {
  .multiselect__single{
    text-transform: none !important;
    overflow: hidden;
  }
}
.guardrail-tags {
  .multiselect__option span{
    text-transform: none !important;
  }
}

</style>
